import Vue from 'vue'
import Router from 'vue-router'
import LoginPage from '@/pages/LoginPage.vue'
import HomePage from '@/pages/HomePage.vue'
import DashboardPage from '@/pages/DashboardPage.vue'
import UserListPage from '@/pages/UserListPage.vue'
import StudentListPage from '@/pages/StudentListPage.vue'
import StudentNewPage from '@/pages/StudentNewPage.vue'
import AttendancePage from '@/pages/AttendancePage.vue'
import ScoreEntryPage from '@/pages/ScoreEntryPage.vue' // Import the new page
import SchoolInfoPage from '@/pages/SchoolInfoPage.vue'
import SchoolFacilitiesPage from '@/pages/SchoolFacilitiesPage.vue'
import SchoolMaterialsPage from '@/pages/SchoolMaterialsPage.vue'
import EducationDevelopmentPlanPage from '@/pages/EducationDevelopmentPlanPage.vue'
import SchoolWasGardenPage from '@/pages/SchoolWasGardenPage.vue'
import SchoolInfrastructurePage from '@/pages/SchoolInfrastructurePage.vue'
import PromotionPage from '@/pages/PromotionPage.vue'
import PromotionHistoryPage from '@/pages/PromotionHistoryPage.vue'
import StaffListPage from '@/pages/StaffListPage.vue'
import StaffFormPage from '@/pages/StaffFormPage.vue'
import CurriculumListPage from '@/pages/CurriculumListPage.vue'
import CurriculumFormPage from '@/pages/CurriculumFormPage.vue'
import AcademicYearListPage from '@/pages/AcademicYearListPage.vue'
import AcademicYearFormPage from '@/pages/AcademicYearFormPage.vue'
import ExamResultsAnnouncementPage from '@/pages/ExamResultsAnnouncementPage.vue'
import UserFormPage from '@/pages/UserFormPage.vue'
import PermissionPage from '@/pages/PermissionPage.vue'
import ChangePasswordPage from '@/pages/ChangePasswordPage.vue'
import ChangeSchoolPage from '@/pages/ChangeSchoolPage.vue'
import ForbiddenPage from '@/pages/ForbiddenPage.vue'
import NotFoundPage from '@/pages/NotFoundPage.vue'
import StudentUpload from '@/pages/StudentUpload.vue'
import SchoolReportPage from '@/pages/SchoolReportPage.vue'
import DistrictReportPage from '@/pages/DistrictReportPage.vue'
import ProvinceReportPage from '@/pages/ProvinceReportPage.vue'
import NationalReportPage from '@/pages/NationalReportPage.vue'
import SchoolManagePage from '@/pages/SchoolManagePage.vue'
import SchoolOverviewPage from '@/pages/SchoolOverviewPage.vue'
import OverseaStudentFormPage from '@/pages/OverseaStudentFormPage.vue'
import OverseaStudentListPage from '@/pages/OverseaStudentListPage.vue'
import OverseaStudentDetailPage from '@/pages/OverseaStudentDetailPage.vue'
import OverseaActiveReportPage from '@/pages/OverseaActiveReportPage.vue'
import OverseaGraduateReportPage from '@/pages/OverseaGraduateReportPage.vue'
import StudentTransferListPage from '@/pages/StudentTransferListPage.vue'
import StudentTransferFormPage from '@/pages/StudentTransferFormPage.vue'
import StudentTransferDetailPage from '@/pages/StudentTransferDetailPage.vue'

import { auth } from '@/utils/auth'
 
 


Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: '/school/',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: LoginPage,
      meta: { requiresAuth: false, isPublic: true }
    },
    {
      path: '/home',
      name: 'Home',
      component: HomePage,
      meta: { requiresAuth: true },
      redirect: '/home/dashboard',
      children: [
        {
          path: '/home/dashboard',
          name: 'Dashboard',
          component: DashboardPage,
          meta: { requiresAuth: true }
        },
        {
          path: '/home/students/new',
          name: 'StudentNew',
          component: StudentNewPage,
          meta: { requiresAuth: true, requiredPermission: { module: 'student-new', bit: 1 } }
        },
        {
          path: '/home/students/attendance',
          name: 'Attendance',
          component: AttendancePage,
          meta: { requiresAuth: true, requiredPermission: { module: 'student-attendance', bit: 1 } }
        },
        {
          path: '/home/students/monthly-scores', // New route for score entry
          name: 'MonthlyScores',
          component: ScoreEntryPage,
          meta: { requiresAuth: true, requiredPermission: { module: 'student-scores', bit: 1 } }
        },
        {
          path: '/home/academic/promotion',
          name: 'Promotion',
          component: PromotionPage,
          meta: { requiresAuth: true, requiredPermission: { module: 'academic-promotion', bit: 1 } }
        },
        {
          path: '/home/academic/promotion-history',
          name: 'PromotionHistory',
          component: PromotionHistoryPage,
          meta: { requiresAuth: true, requiredPermission: { module: 'academic-promotion-history', bit: 0 } }
        },
        {
          path: '/home/staff/list',
          name: 'StaffList',
          component: StaffListPage,
          meta: { requiresAuth: true, requiredPermission: { module: 'staff-list', bit: 0 } }
        },
        {
          path: '/home/staff/new',
          name: 'StaffNew',
          component: StaffFormPage,
          meta: { requiresAuth: true, requiredPermission: { module: 'staff-new', bit: 1 } }
        },
        {
          path: '/home/staff/edit/:id',
          name: 'StaffEdit',
          component: StaffFormPage,
          props: true,
          meta: { requiresAuth: true, requiredPermission: { module: 'staff-list', bit: 1 } }
        },
        {
          path: '/home/school/info',
          name: 'SchoolInfo',
          component: SchoolInfoPage,
          meta: { requiresAuth: true, requiredPermission: { module: 'school-info', bit: 1 } }
        },
        {
          path: '/home/school/infrastructure',
          name: 'SchoolInfrastructure',
          component: SchoolInfrastructurePage,
          meta: { requiresAuth: true, requiredPermission: { module: 'school-infrastructure', bit: 1 } }
        },
        {
          path: '/home/school/facilities',
          name: 'SchoolFacilities',
          component: SchoolFacilitiesPage,
          meta: { requiresAuth: true, requiredPermission: { module: 'school-facilities', bit: 1 } }
        },
        {
          path: '/home/school/was-garden',
          name: 'SchoolWasGarden',
          component: SchoolWasGardenPage,
          meta: { requiresAuth: true, requiredPermission: { module: 'school-was-garden', bit: 1 } }
        },
        {
          path: '/home/school/materials',
          name: 'SchoolMaterials',
          component: SchoolMaterialsPage,
          meta: { requiresAuth: true, requiredPermission: { module: 'school-materials', bit: 1 } }
        },
        {
          path: '/home/school/education-plan',
          name: 'EducationDevelopmentPlan',
          component: EducationDevelopmentPlanPage,
          meta: { requiresAuth: true, requiredPermission: { module: 'school-education-plan', bit: 1 } }
        },
        {
          path: '/home/academic/curriculum',
          name: 'CurriculumList',
          component: CurriculumListPage,
          meta: { requiresAuth: true, requiredPermission: { module: 'academic-curriculum', bit: 0 } }
        },
        {
          path: '/home/academic/curriculum/new',
          name: 'CurriculumNew',
          component: CurriculumFormPage,
          meta: { requiresAuth: true, requiredPermission: { module: 'academic-curriculum', bit: 1 } }
        },
        {
          path: '/home/academic/curriculum/edit/:id',
          name: 'CurriculumEdit',
          component: CurriculumFormPage,
          props: true,
          meta: { requiresAuth: true, requiredPermission: { module: 'academic-curriculum', bit: 1 } }
        },
        {
          path: '/home/system/permissions',
          name: 'SystemPermissions',
          component: PermissionPage,
          meta: { requiresAuth: true, requiredPermission: { module: 'system-permissions', bit: 1 } }
        },
        {
          path: '/home/system/users',
          name: 'UserList',
          component: UserListPage,
          meta: { requiresAuth: true, requiredPermission: { module: 'system-users', bit: 0 } }
        },
        {
          path: '/home/students/exam-results',
          name: 'ExamResults',
          component: ExamResultsAnnouncementPage,
          meta: { requiresAuth: true, requiredPermission: { module: 'student-exams', bit: 0 } }
        },
        {
          path: '/home/students/list',
          name: 'StudentList',
          component: StudentListPage,
          meta: { requiresAuth: true, requiredPermission: { module: 'student-list', bit: 0 } }
        },
        {
          path: '/home/students/edit/:id',
          name: 'StudentEdit',
          component: StudentNewPage,
          props: true,
          meta: { requiresAuth: true, requiredPermission: { module: 'student-list', bit: 1 } }
        },
         {
          path: '/home/students/import',
          name: 'StudentImport',
          component: StudentUpload,
          meta: { requiresAuth: true, requiredPermission: { module: 'student-import', bit: 0 } }
        },
        {
          path: '/home/students/oversea/list',
          name: 'OverseaStudentList',
          component: OverseaStudentListPage,
          meta: { requiresAuth: true, requiredPermission: { module: 'student-oversea-list', bit: 0 } }
        },
        {
          path: '/home/students/oversea/detail/:id',
          name: 'OverseaStudentDetail',
          component: OverseaStudentDetailPage,
          props: true,
          meta: { requiresAuth: true, requiredPermission: { module: 'student-oversea-list', bit: 0 } }
        },
        {
          path: '/home/students/oversea/new',
          name: 'OverseaStudentNew',
          component: OverseaStudentFormPage,
          meta: { requiresAuth: true, requiredPermission: { module: 'student-oversea-new', bit: 1 } }
        },
        {
          path: '/home/students/oversea/edit/:id',
          name: 'OverseaStudentEdit',
          component: OverseaStudentFormPage,
          props: true,
          meta: { requiresAuth: true, requiredPermission: { module: 'student-oversea-new', bit: 1 } }
        },
        {
          path: '/home/system/users/new',
          name: 'UserAdd',
          component: UserFormPage,
          meta: { requiresAuth: true, requiredPermission: { module: 'system-user-new', bit: 1 } }
        },
        {
          path: '/home/system/users/edit/:id',
          name: 'UserEdit',
          component: UserFormPage,
          props: true,
          meta: { requiresAuth: true, requiredPermission: { module: 'system-users', bit: 1 } }
        },
        {
          path: '/home/system/users/change-password',
          name: 'ChangePassword',
          component: ChangePasswordPage,
          meta: { requiresAuth: true,   }
        },
        {
          path: '/home/system/change-school',
          name: 'ChangeSchool',
          component: ChangeSchoolPage,
          meta: { requiresAuth: true, requiredPermission: { module: 'system-change-school', bit: 0 } }
        },
        {
          path: '/home/academic/year/list',
          name: 'AcademicYearList',
          component: AcademicYearListPage,
          meta: { requiresAuth: true, requiredPermission: { module: 'academic-year', bit: 0 } }
        },
        {
          path: '/home/academic/year/new',
          name: 'AcademicYearNew',
          component: AcademicYearFormPage,
          meta: { requiresAuth: true, requiredPermission: { module: 'academic-year', bit: 1 } }
        },
        {
          path: '/home/academic/year/edit/:id',
          name: 'AcademicYearEdit',
          component: AcademicYearFormPage,
          props: true,
          meta: { requiresAuth: true, requiredPermission: { module: 'academic-year', bit: 1 } },
        },
        {
          path: '/home/reports/school',
          name: 'SchoolReport',
          component: SchoolReportPage,
          meta: { requiresAuth: true, requiredPermission: { module: 'report-school', bit: 0 } }
        },
        {
          path: '/home/reports/district-stats',
          name: 'DistrictReport',
          component: DistrictReportPage,
          meta: { requiresAuth: true, requiredPermission: { module: 'report-district', bit: 0 } }
        },
        {
          path: '/home/reports/province-stats',
          name: 'ProvinceReport',
          component: ProvinceReportPage,
          meta: { requiresAuth: true, requiredPermission: { module: 'report-province', bit: 0 } }
        },
        {
          path: '/home/reports/national-stats',
          name: 'NationalReport',
          component: NationalReportPage,
          meta: { requiresAuth: true, requiredPermission: { module: 'report-national', bit: 0 } }
        },
        {
          path: '/home/system/schools',
          name: 'SchoolManage',
          component: SchoolManagePage,
          meta: { requiresAuth: true, requiredPermission: { module: 'system-schools', bit: 0 } }
        },
        {
          path: '/home/school/overview',
          name: 'SchoolOverview',
          component: SchoolOverviewPage,
          meta: { requiresAuth: true, requiredPermission: { module: 'school-overview', bit: 0 } }
        },
        {
          path: '/home/reports/oversea-active',
          name: 'OverseaActiveReport',
          component: OverseaActiveReportPage,
          meta: { requiresAuth: true, requiredPermission: { module: 'report-oversea-active', bit: 0 } }
        },
        {
          path: '/home/reports/oversea-graduate',
          name: 'OverseaGraduateReport',
          component: OverseaGraduateReportPage,
          meta: { requiresAuth: true, requiredPermission: { module: 'report-oversea-graduate', bit: 0 } }
        },
        {
          path: '/home/students/transfer/list',
          name: 'StudentTransferList',
          component: StudentTransferListPage,
          meta: { requiresAuth: true, requiredPermission: { module: 'student-transfer-list', bit: 0 } }
        },
        {
          path: '/home/students/transfer/new',
          name: 'StudentTransferNew',
          component: StudentTransferFormPage,
          meta: { requiresAuth: true, requiredPermission: { module: 'student-transfer-new', bit: 1 } }
        },
        {
          path: '/home/students/transfer/edit/:id',
          name: 'StudentTransferEdit',
          component: StudentTransferFormPage,
          props: true,
          meta: { requiresAuth: true, requiredPermission: { module: 'student-transfer-new', bit: 1 } }
        },
        {
          path: '/home/students/transfer/detail/:id',
          name: 'StudentTransferDetail',
          component: StudentTransferDetailPage,
          props: true,
          meta: { requiresAuth: true, requiredPermission: { module: 'student-transfer-list', bit: 0 } }
        }
      ]
    },
    {
      path: '/forbidden',
      name: 'Forbidden',
      component: ForbiddenPage,
      meta: { requiresAuth: true }
    },
    // ຕ້ອງໄວ້ລຸ່ມສຸດສະເໝີ
    {
      path: '*',
      name: 'NotFound',
      component: NotFoundPage,
      meta: { requiresAuth: false }
    },
  ],
})

/**
 * Route guard - Check authentication before each navigation
 */
router.beforeEach((to, from, next) => {
  const isAuthenticated = auth.isAuthenticated();
  const requiresAuth = to.meta.requiresAuth !== false;

  // 1. ຍັງບໍ່ໄດ້ login ແຕ່ route ຕ້ອງການ auth
  if (requiresAuth && !isAuthenticated) {
    return next({ name: 'Login', query: { redirect: to.fullPath } });
  }

  // 2. login ແລ້ວ ແຕ່ພະຍາຍາມເຂົ້າໜ້າ public (ເຊັ່ນ: login page)
  if (isAuthenticated && to.meta.isPublic) {
    return next({ name: 'Dashboard' });
  }

  // 3. ກວດສິດ Bitwise (ຕ້ອງກວດກ່ອນ catch-all authenticated block)
  if (isAuthenticated && to.meta.requiredPermission) {
    const userInfo = auth.getUserInfo();
    if (!userInfo) return next({ name: 'Login' });

    // Admin (Level 1) ຜ່ານທຸກໜ້າ
    if (parseInt(userInfo.user_level) === 1) return next();

    const { module, bit } = to.meta.requiredPermission;
    const pVal = (userInfo.permissions || {})[module] || 0;

    if ((pVal & (1 << bit)) !== 0) {
      return next();
    }
    console.warn(`Access denied: module=${module}, bit=${bit}`);
    return next({ name: 'Forbidden' });
  }

  // 4. ທຸກກໍລະນີອື່ນ — ອະນຸຍາດ
  next();
});

/**
 * ລະບົບ Logout ອັດຕະໂນມັດ (Auto Logout)
 * ຕິດຕາມການເຄື່ອນໄຫວ ແລະ Logout ຖ້າປະໄວ້ເກີນ 30 ນາທີ
 */
const INACTIVITY_LIMIT = 30 * 60 * 1000; // 30 ນາທີ
const WARNING_LIMIT = 29 * 60 * 1000;    // 29 ນາທີ (ແຈ້ງເຕືອນກ່ອນ 1 ນາທີ)
let warningShown = false;

/**
 * ສ້າງ ແລະ ສະແດງ Custom Modal ສໍາລັບແຈ້ງເຕືອນ Session
 */
const showSessionModal = (onConfirm, onLogout) => {
  // ສ້າງ Overlay
  const overlay = document.createElement('div');
  overlay.id = 'session-timeout-overlay';
  Object.assign(overlay.style, {
    position: 'fixed', top: '0', left: '0', width: '100%', height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.4)', backdropFilter: 'blur(8px)',
    display: 'flex', justifyContent: 'center', alignItems: 'center',
    zIndex: '9999', animation: 'fadeIn 0.3s ease'
  });

  // ສ້າງ Card
  const card = document.createElement('div');
  Object.assign(card.style, {
    backgroundColor: 'white', padding: '30px', borderRadius: '16px',
    boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)', maxWidth: '400px',
    width: '90%', textAlign: 'center', animation: 'slideDown 0.3s ease'
  });

  // ເພີ່ມເນື້ອຫາ
  card.innerHTML = `
    <div style="color: #003f8a; font-size: 48px; margin-bottom: 20px;">
      <i class="fas fa-clock"></i>
    </div>
    <h2 style="margin: 0 0 15px; color: #1e293b; font-size: 1.25rem; font-family: 'Phetsarath OT'">ເວລານຳໃຊ້ໃກ້ຈະໝົດແລ້ວ</h2>
    <p style="margin: 0 0 25px; color: #64748b; line-height: 1.6; font-family: 'Phetsarath OT'">
      ທ່ານບໍ່ມີການເຄື່ອນໄຫວເປັນເວລາດົນ. ລະບົບຈະອອກຈາກລະບົບອັດຕະໂນມັດພາຍໃນ <b>1 ນາທີ</b> ເພື່ອຄວາມປອດໄພ.
    </p>
    <div style="display: flex; gap: 12px; justify-content: center;">
      <button id="btn-session-logout" style="padding: 10px 20px; border: 1px solid #e2e8f0; background: white; color: #64748b; border-radius: 8px; cursor: pointer; font-weight: 600; font-family: 'Phetsarath OT'">ອອກຈາກລະບົບ</button>
      <button id="btn-session-stay" style="padding: 10px 20px; border: none; background: #003f8a; color: white; border-radius: 8px; cursor: pointer; font-weight: 600; font-family: 'Phetsarath OT'">ສືບຕໍ່ການນຳໃຊ້</button>
    </div>
  `;

  // ເພີ່ມ Style Animation ໃຫ້ Head
  if (!document.getElementById('session-modal-style')) {
    const style = document.createElement('style');
    style.id = 'session-modal-style';
    style.innerHTML = `
      @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
      @keyframes slideDown { from { transform: translateY(-20px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
    `;
    document.head.appendChild(style);
  }

  overlay.appendChild(card);
  document.body.appendChild(overlay);

  // ເພີ່ມ Event Listeners
  document.getElementById('btn-session-stay').onclick = () => {
    document.body.removeChild(overlay);
    onConfirm();
  };
  document.getElementById('btn-session-logout').onclick = () => {
    document.body.removeChild(overlay);
    onLogout();
  };
};

/**
 * ລຶບ Modal ອອກຖ້າມີຄ້າງຢູ່
 */
const removeSessionModal = () => {
  const existing = document.getElementById('session-timeout-overlay');
  if (existing) document.body.removeChild(existing);
};

const resetTimer = () => {
  if (auth.isAuthenticated()) {
    localStorage.setItem('lastActivity', Date.now().toString());
    warningShown = false; // Reset ສະຖານະການແຈ້ງເຕືອນເມື່ອມີການເຄື່ອນໄຫວ
    removeSessionModal();
  }
};

const checkInactivity = () => {
  const lastActivity = localStorage.getItem('lastActivity');
  if (auth.isAuthenticated() && lastActivity) {
    const elapsed = Date.now() - parseInt(lastActivity);

    if (elapsed > INACTIVITY_LIMIT) {
      removeSessionModal();
      auth.logout();
      router.push({ name: 'Login', query: { message: 'session_expired' } });
      warningShown = false;
    } else if (elapsed > WARNING_LIMIT && !warningShown) {
      warningShown = true;
      showSessionModal(
        () => resetTimer(),
        () => {
          auth.logout();
          router.push({ name: 'Login', query: { message: 'manual_logout' } });
        }
      );
    }
  }
};

// ລົງທະບຽນ Event ເພື່ອຕິດຕາມການເຄື່ອນໄຫວ
['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'].forEach(event => {
  window.addEventListener(event, resetTimer);
});

// ກວດສອບທຸກໆ 1 ນາທີ
setInterval(checkInactivity, 60000);

export default router
